import httpManager from "@/app/shared/utils/httpManager";

/**
 * Cambiar estado de un contacto.
 *
 */
export async function updateStatusContact(clientIds, status) {
  return await httpManager.post(`/contacts/clients/status-update/`, 
    {
      client_ids: clientIds,
      status: status
    }
  );
}
